import { c as _c } from "react/compiler-runtime";
import type { ApiNodeDataBranch } from '@onefootprint/request-types/dashboard';
import type { NodeProps } from '@/playbook-builder/playbook-builder.types';
import { useGetNodeConfigContext } from '../../hooks/use-get-node-config-context';
import useStore from '../../hooks/use-store';
import BaseNode from '../base-node';
import BranchNodeContent from './components/branch-node-content';
export const BranchNode = node => {
  const $ = _c(8);
  const {
    data: t0
  } = useStore();
  const {
    canEdit
  } = t0;
  const config = useGetNodeConfigContext(node.id, "branch");
  if (node.data.context?.context?.kind !== "branch") {
    return null;
  }
  let t1;
  if ($[0] !== canEdit || $[1] !== config || $[2] !== node) {
    t1 = {
      form: "branch-node-form",
      size: "lg",
      render: t2 => {
        const {
          mutation
        } = t2;
        return <BranchNodeContent node={node} mutation={mutation} canEdit={canEdit} config={config} />;
      }
    };
    $[0] = canEdit;
    $[1] = config;
    $[2] = node;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== node.data || $[5] !== node.id || $[6] !== t1) {
    t2 = <BaseNode nodeId={node.id} data={node.data} collapsible={true} sidebar={t1} />;
    $[4] = node.data;
    $[5] = node.id;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default BranchNode;